<template>
  <div class="box-second">
    <p class="title-crumb">
          <el-breadcrumb separator-class="el-icon-arrow-right color3">
              <el-breadcrumb-item>电子图纸</el-breadcrumb-item>
              <!-- <el-breadcrumb-item>班组信息</el-breadcrumb-item> -->
          </el-breadcrumb>
      </p>
    <div class="main">
      <div class="main-left">
        <el-tree :data="dataTree" ref="tree" :props="defaultProps" @node-click="handleNodeClick" node-key='id'
          highlight-current default-expand-all>
          <span class="span-ellipsis" slot-scope="{ node, data }"
            style="width: 100%;text-align: left;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
            <span :title="node.label" class="">{{data.name}}</span>
          </span>
        </el-tree>
      </div>
      <div class="main-table">
        <div class="table-head">
          <div class="table-head-seach">
            <span>文件名称:</span>
            <el-input placeholder="请输入文件名称" v-model="search.fileName" clearable style="margin-right:1vw;"></el-input>
            <span>审核状态:</span>
            <el-select v-model="search.checkCode" filterable clearable placeholder="请选择" >
              <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id"></el-option>
           </el-select>
           <el-button  style="margin-left:10px;background:#275bcf" type="primary"  @click="doFile">查询</el-button>
          </div>
          <!-- <el-upload
                      class="upload-demo"
                      v-bind:action="uploadUrl"
                      :headers="uploadHead"
                      :data={type:225}
                      :show-file-list="false"
                      :on-success="fileSuccess">
                      <el-button size="small" style="background: #285bd0;" type="primary" class="primary">点击上传</el-button>
                  </el-upload> -->
          <!-- <el-button type="primary" size="mini" plain icon="el-icon-plus" @click="addTeam">添加文件</el-button> -->
        </div>
        <div class="table-box">
          <el-table :data="tableDataEnd" height="100%" style="width: 100%"
            :header-cell-style="{background:'#F5F7F9',color:'#909399'}">
            <template slot="empty">
              <p>{{dataText}}</p>
            </template>
            <el-table-column label="序号" type="index" width="80"></el-table-column>
            <el-table-column label="文件名称"  show-overflow-tooltip>
              <template slot-scope="scope">
                <!--  <router-link :to="'/teamWorker/'+scope.row.id" class="color5" :title="scope.row.name">{{scope.row.name}}</router-link> -->
                <div style="width:100%;height:100%;display:flex;align-items: center;" @click="showFile(scope.row)">
                  <img v-if="scope.row.fileFormat=='0'" src="../../assets/image/office/undefined.png"
                    style="width:5vh;height:5vh;" />
                  <img v-else-if="scope.row.fileFormat=='1'" src="../../assets/image/office/word.png"
                    style="width:5vh;height:5vh;" />
                  <img v-else-if="scope.row.fileFormat=='2'" src="../../assets/image/office/excel.png"
                    style="width:5vh;height:5vh;" />
                  <img v-else-if="scope.row.fileFormat=='3'" src="../../assets/image/office/pdf.png"
                    style="width:5vh;height:5vh;" />
                  <img v-else-if="scope.row.fileFormat=='4'" src="../../assets/image/office/photo.png"
                    style="width:5vh;height:5vh;" />
                  <img v-else src="../../assets/image/office/undefined.png" style="width:5vh;height:5vh;" />
                  <span style="padding-left:1vw;">{{scope.row.fileName}}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="文件大小(KB)">
              <template slot-scope="scope">
                <span>{{ scope.row.fileSize }}</span>
              </template>
            </el-table-column>
            <el-table-column label="上传日期"  show-overflow-tooltip> 
              <template slot-scope="scope">
                <span>{{ scope.row.createDate }}</span>
              </template>
            </el-table-column>
            <el-table-column label="审核状态">
              <template slot-scope="scope">
                <div @click="proccess(scope.$index, scope.row)" style="cursor: pointer;">
                  <span style="color: burlywood;" v-if="scope.row.checkCode==0">未审核</span>
                  <span style="color: #67c23a;" v-if="scope.row.checkCode==1">审核成功 </span>
                  <span style="color: crimson;" v-if="scope.row.checkCode==2">审核失败</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="备注">
              <template slot-scope="scope">
                <span>{{ scope.row.remark }}</span>
              </template>
            </el-table-column>
            <el-table-column label="审核">
              <template slot-scope="scope">
                <el-button type="success" v-if="scope.row.checkCode==0" size="mini"
                @click="handleCheck(scope.$index, scope.row,1)">通过</el-button>
                <el-button type="warning" v-if="scope.row.checkCode==0" size="mini"
                @click="handleCheck(scope.$index, scope.row,2)">不通过</el-button>
                <el-button type="danger" v-if="scope.row.checkCode!=0" size="mini">已审核</el-button>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="250">
              <template slot-scope="scope">
                <el-button size="mini" @click="handleDown(scope.$index, scope.row)">下载</el-button>
                <!-- <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button> -->
               <el-button size="mini" @click="erCode(scope.$index, scope.row)">二维码</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页展示 -->
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[20, 50, 100, 200]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="totalItems" style="padding-top:10px;">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 新增窗口 -->
    <el-dialog :title="entTitle" :visible.sync="entVisible" center :append-to-body="true" :lock-scroll="false"
      width="30%">
      <el-form :model="addFolder" ref="addFolder" :rules="rules" label-width="200px" label-position="right"
        class="joinEnt">
        <el-form-item label="文件名：" prop="fileName">
          <el-input  v-model="addFolder.filesName" autocomplete="off" style="width:220px"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="entVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbitAddFolder('addFolder')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 审核弹出框 -->
    <el-dialog :title="codeTit" :visible.sync="codeVis" center :append-to-body="true" :lock-scroll="false" width="30%"
      style="height:100%;">
      <el-form :model="codeFrom" ref="codeFrom" :rules="rules" label-width="200px" label-position="right"
        class="joinEnt">
        <el-form-item label="备注:" prop="remark">
          <el-input type="textarea" v-model="codeFrom.remark" autocomplete="off" style="width:220px" :rows="16"></el-input>
        </el-form-item>
        <el-form-item label="审核人:" prop="remark">
          <el-input  v-model="codeFrom.checkName" autocomplete="off" style="width:220px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="codeVis = false">取 消</el-button>
        <el-button type="primary" @click="codeVisAddRow('codeFrom')">确 定</el-button>
      </div>
    </el-dialog>
       <!-- 二维码弹出框 -->
       <el-dialog
       :title="codeTit"
       :visible.sync="codeVis1"
       center
       :append-to-body="true"
       :lock-scroll="false"
       width="30%"
       style="height:100%;"
       :before-close="handleCloseback"
   >
       <div class="erCode">
           <vue-qr :text="codeUrl" :size="200"></vue-qr>
           <!-- <p style="width:100%;text-align:center;">
               <el-button type="primary" @click="downCode">确 定</el-button>
           </p> -->
       </div>
       </el-dialog>
    <!-- 添加文件 -->
    <el-dialog :title="diaTitle" :visible.sync="addFormVisible" center :append-to-body="true" :lock-scroll="false"
      width="30%">
      <el-form :model="addForm" ref="addForm" label-width="150px" label-position="right" class="teamPage"
        :rules="teamRules">
        <el-form-item label="上传文件:" prop="managerTel">
          <el-upload class="upload-demo" v-bind:action="uploadUrl" :headers="uploadHead"
            :data={type:245,projectId:projectId} :show-file-list="false" :on-success="fileSuccess">
            <!-- <el-button size="small" style="background: #285bd0;" type="primary" class="primary">点击上传</el-button> -->
            <i v-if="!addForm.fileUrl" class="el-icon-plus avatar-uploader-icon"></i>
            <!-- <img v-if="scope.row.fileFormat=='0'" src="../../assets/image/office/undefined.png" style="width:5vh;height:5vh;"  />
                      <img v-else-if="scope.row.fileFormat=='1'" src="../../assets/image/office/word.png" style="width:5vh;height:5vh;" />
                      <img v-else-if="scope.row.fileFormat=='2'" src="../../assets/image/office/excel.png" style="width:5vh;height:5vh;" />
                      <img v-else-if="scope.row.fileFormat=='3'" src="../../assets/image/office/pdf.png" style="width:5vh;height:5vh;" />
                      <img v-else-if="scope.row.fileFormat=='4'" src="../../assets/image/office/photo.png" style="width:5vh;height:5vh;" /> -->
            <div style="display: flex;justify-content: space-between;align-items: center;">
              <img v-if="addForm.fileUrl" src="../../assets/image/fileicon.png" style="width:5vh;height:5vh;" />
              <span v-if="addForm.fileUrl">{{addForm.fileName}}</span>
            </div>

          </el-upload>
        </el-form-item>
        <el-form-item label="排序:" prop="fileName">
          <el-input v-model="addFolder.filesName" autocomplete="off" style="width:220px"></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input v-model="addForm.remarks" type="textarea" placeholder="请输入内容" autocomplete="off" 
            style="width:220px" :rows="16"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
      </div>
    </el-dialog>
     <!-- 审批流弹框 -->
     <el-dialog :title="processTitle" :visible.sync="processVisible" center :append-to-body="true"
     :before-close="handleCloseprocess" :lock-scroll="false" width="35%" height="700px">
     <div style="height: 350px;    overflow: auto;">
       <el-steps direction="vertical">
         <el-step v-for="(item,index) in processList" :key="index" process-status="success">
           <template slot="description">
             <div>
               <div class="stepNoBtn">
                 <div class="step-title-font">处理人:{{ item.createBy }}</div>
                 <div class="step-title-font">处理时间:{{ item.createDate }}</div>
                 <!-- <div>处理状态：{{item.codeStatus}} </div> -->
                 <div>处理意见：{{item.fileRemark||'无'}}</div>
               </div>
             </div>
           </template>
         </el-step>
       </el-steps>
     </div>
   </el-dialog>
  </div>
</template>
<script>
  import util from '../../untils/util'
  import myHttp from '../../untils/port'
  import base from '../../untils/base'
  import vueQr from 'vue-qr'
  export default {
    components: {
      vueQr
    },
    data() {
      return {
        projectId: '',
        dataTree: [],
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        entName: '',//参建单位查询
        groupId: '',
        folderList: [],//参建单位list
        entsTypes: [],//参建单位类型list
        entTitle: '',//参建单位弹出框名称
        entVisible: false,
        persons: [],//参建单位的管理人员
        addFolder: {
          filesType: '1',
          type: '1',
          id: '',
          groupId: '',
          filesName: '',
          userType: ''
        },
        search:{
          fileName:'',
          checkCode:''
        },
        rules: {
          filesName: [
            { required: true, message: '请填写文件名称', trigger: 'blur' }
          ],
        },
        folderId: '',//当前展示文件夹id
        tableDataEnd: [],//班组列表
        diaTitle: '添加文件夹',//班组添加名称
        dataText: '数据加载中...',
        teamName: '',//班组名称
        uploadUrl: base.url + "/upload/uploadFile",//上传地址
        uploadHead: {  //上传接口header
          accessToken: this.$store.state.token
        },
        //二维码
        codeVis: false,
        codeUrl: '',
        codeTit: '',
        diaTitle: '添加',//班组添加名称
        addFormVisible: false,//班组添加弹出框
        teamRules: {},
        addForm: {
          id: '',
          fileName: '',
          fileSize: '',
          fileType: '',
          fileUrl: '',
          remark: '',
          sort: ''
        },
        currentPage: 1,
        pageSize: 10,
        totalItems: 0,
        codeFrom:{
          fileId:'',
          checkCode:'',
          remark:'',
          checkName:''
        },
        codeVis1:false,
        prot:'',
        statusList:[{name:'未审核',id:'0'},{name:'审核成功',id:'1'},{name:'审核失败',id:'2'},],
        tableDataEnd: [],
        processList: [],
        processTitle: '流程',
        processVisible: false,
        processForm: {

        },
      }
    },
    mounted() {
      this.prot= util.session.get('roleId')
      this.groupId = util.session.get('groupId')

      this.getTreeData()
      // this.getPerson()
    },
    methods: {
      handleSizeChange(val) {
        this.pageSize = val
        this.handleCurrentChange(this.currentPage)
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.currentChangePage()
      },
      // 监控当前页码
      currentChangePage(list) {
        this.getFolder()
      },
      getTreeData() {
        var that = this
        myHttp.findOfficeTreeList({
          entId: this.groupId,
          // levelType:3
        }).then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data || []
            var curKey = ''
            var projectId = ''
            if (list.length > 0) {
              for(var i = 0;i<list.length;i++){
                for(var j = 0;j<list[i].children.length;j++){
                  if(list[i].children[j].id){
                  curKey = list[i].children[j].id

                  }
                }
              }
              // curKey = list[0].children[0].id
              that.dataTree = list
              that.projectId = curKey            
              that.getFolder()
            }else{
              that.dataText = '暂无数据'
            }
            setTimeout(function () {
              that.$refs.tree.setCurrentKey(curKey)
            }, 100)
          }
        })
      },
      doFile(){
        this.getTreeData()
      },
      //获取文件夹
      getFolder() {
        var that = this
        myHttp.findProjectFileList({
          projectId: '1',
          fileType: '3',
          projectId: this.projectId,
          pageNum: this.currentPage,
          pageSize: this.pageSize

        }).then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.list || []
            if (list.length > 0) {
              for (var i = 0; i < list.length; i++) {
                list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
                list[i].fileFormat = list[i].fileName && list[i].fileName != '' ? that.getImg(list[i].fileName) : '0'
              }
              that.tableDataEnd = list
            } else {
              that.dataText = '暂无数据'
            }
            that.folderList = list
          } else {

          }
        })
      },
      //添加参建单位
      addEntFun() {
        this.entVisible = true
        this.addFolder.filesName = ''
        this.addFolder.id = ''
        this.entTitle = '添加文件夹'

      },

      //添加或者修改文件夹
      sumbitAddFolder(formName) {
        var that = this
        this.addFolder.createBy = util.session.get('user').id
        this.addFolder.groupId = this.groupId
        this.addFolder.userType = util.session.get('roleId')
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (this.addFolder.id == '') {
              myHttp.addFolderFiles(this.addFolder).then(function (resp) {
                if (resp.data.code == '200') {
                  that.$message.success('添加成功')
                  that.entVisible = false
                  that.getFolder()
                } else {
                  that.$message.error(resp.data.msg)
                }
              })
            } else {
              myHttp.updateFiles(this.addFolder).then(function (resp) {
                if (resp.data.code == '200') {
                  that.$message.success('修改成功')
                  that.entVisible = false
                  that.getFolder()
                } else {
                  that.$message.error(resp.data.msg)
                }
              })
            }
          } else {
            return false
          }
        })
      },
      //选择展示的文件夹
      getEntId(row) {
        this.folderId = row.id
        this.getFolder()
      },
      //获取图片
      getImg(url) {
        // 1:word   2:excel    3:pdf     4:img   5:undefined
        var result = '';
        var list = url.split('.')
        var str = list[list.length - 1]
        if (base.docType.indexOf(str) >= 0) {
          result = '1'
        } else if (base.imgType.indexOf(str) >= 0) {
          result = '4'
        } else if (base.excelType.indexOf(str) >= 0) {
          result = '2'
        } else if (base.pdfType.indexOf(str) >= 0) {
          result = '3'
        } else {
          result = '5'
        }
        return result
      },
      /**
       * 根据名称查询班组
       */
      doFilter() {
        this.getTeam()
      },
      /**
       * 添加文件
       */
      addTeam() {
        this.addFormVisible = true
        // this.teamPersons = []
        // this.getPerson()
        this.addForm = {
          id: '',
          fileName: '',
          fileSize: '',
          fileType: '',
          fileUrl: '',
          remark: '',
          sort: '',

        }
        this.diaTitle = '添加'
      },
      // 修改文件
      handleEdit(index, row) {
        this.addFormVisible = true
        this.persons = []
        this.getPersonByTeam(row.id)
        this.addForm.id = row.id
        this.addForm.projectId = row.projectId
        this.addForm.name = row.name
        this.addForm.teamsType = row.teamsType
        this.addForm.creditCode = row.creditCode
        this.addForm.entName = row.entName
        this.addForm.entId = row.entId
        this.addForm.remarks = row.remarks
        this.addForm.teamManager = row.teamManager
        this.addForm.managerTel = row.managerTel
        this.addForm.joinTypeName = row.joinTypeName
        this.addForm.deviceSn = row.deviceSn
        this.diaTitle = '修改'
      },
      //展示
      showFile(row) {
        var that = this
        window.open(base.httpCtx + row.fileUrl);

      },
      //下载
      handleDown(index, row) {
        window.open(base.httpCtx + row.fileUrl)
      },

      // 删除班组
      handleDelete(index, row) {
        var that = this
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          myHttp.deleteFiles({
            id: row.id,
            updateBy: util.session.get('user').id
          }).then(function (resp) {
            if (resp.data.code == '200') {
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
              that.getFolder()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
        }).catch(err => { })
      },
      //上传成功
      fileSuccess(res, file, opt) {
        var that = this
        if (res.code == 200) {
          console.log(res)
          console.log(file)
            this.addForm.fileType = '3',
            this.addForm.fileName = file.name,
            this.addForm.fileUrl = res.data.fileUrl,
            this.addForm.fileSize = res.data.fileSize,
            this.addForm.projectId = this.projectId,
            this.addForm.createBy = util.session.get('user').id

          // myHttp.addFolderFiles(obj).then(function(resp){
          //     if(resp.data.code=='200'){
          //         that.$message.success('添加成功')
          //         that.getFolder()
          //     }else{
          //         that.$message.error(resp.data.msg)
          //     }
          // })
        } else {
          this.$message.error(res.msg);
        }

      },
      //编辑文件夹
      editFolder(obj) {
        this.entVisible = true
        this.addFolder.filesName = obj.filesName
        this.addFolder.id = obj.id

        this.entTitle = '修改文件夹'

      },
      //删除文件夹
      delFolder(obj) {

        var that = this
        this.$confirm('此操作将永久删除该文件夹及其中的文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          myHttp.deleteFiles({
            id: obj.id,
            updateBy: util.session.get('user').id
          }).then(function (resp) {
            if (resp.data.code == '200') {
              that.$message.success('删除成功')
              that.getFolder()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
        })
      },
      // 将新增的数据添加到表格中
      sumbitAddRow(formName) {
        var that = this
        // console.log(this.addForm)
        // this.addForm.userId = this.$store.state.user.id
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (this.addForm.id == '') {
              myHttp.addProjectFile(this.addForm).then(function (resp) {
                if (resp.data.code == '200') {
                  that.$message.success('添加成功')
                  that.addFormVisible = false
                  that.getFolder()
                } else {
                  that.$message.error(resp.data.msg)
                }
              })
            } else {
              myHttp.updateTeams(this.addForm).then(function (resp) {
                if (resp.data.code == '200') {
                  that.$message.success('修改成功')
                  that.addFormVisible = false
                  that.getFolder()
                } else {
                  that.$message.error(resp.data.msg)
                }
              })
            }
          } else {
            //console.log('error submit!!')
            return false
          }
        })
      },
      codeVisAddRow(formName){
          var that = this
          this.$refs[formName].validate(valid => {
          if (valid) {
            // if (this.addForm.id == '') {
              myHttp.checkProjectFile(this.codeFrom).then(function (resp) {
                if (resp.data.code == '200') {
                  that.$message.success('提交成功')
                  that.codeVis = false
                  that.getFolder()
                } else {
                  that.$message.error(resp.data.msg)
                }
              })
            // } 
          } else {
            //console.log('error submit!!')
            return false
          }
        })
      },
      //展示二维码
      erCode(index, row) {
        this.codeVis1 = true
        this.codeUrl = base.httpCtx + row.fileName
        this.codeTit = row.fileName
      },
      /**
         * 点击
         */
      handleNodeClick(e) {
        console.log(e)
        // if(e.level=='1'){
        //     this.opt.projectId = ''
        //     this.opt.entId = ''
        // }else if(e.level=='2'){
        //     this.opt.projectId = e.id
        //     this.opt.entId = ''
        // }else{
        //     this.opt.projectId = e.parentId
        //     this.opt.entId = e.id
        // }
        this.tableDataEnd = []
        this.projectId = e.id
        this.getFolder()
      },
      handleCheck(index, row,checkCode) {
        this.codeFrom.checkCode = checkCode,
        this.codeFrom.fileId = row.fileId,
        this.codeVis = true
        var that = this
        // this.$confirm('此操作将永久, 是否继续?', '提示', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning'
        // }).then(() => {
        //     myHttp.deleteFiles({
        //         id: obj.id,
        //         updateBy:util.session.get('user').id
        //     }).then(function(resp) {
        //         if (resp.data.code == '200') {
        //         that.$message.success('删除成功')
        //         that.getFolder()
        //         } else {
        //         that.$message.error(resp.data.msg)
        //         }
        //     })
        // })
      },
      handleCloseback(){
        this.codeVis1 = false
      },
      handleCloseprocess(){
        this.processVisible = false
      },
      proccess(index, row) {
        this.processVisible = true
        this.processForm.fileId = row.fileId
        this.getProcess()
      },
      getProcess() {
        var that = this
        this.processList = []
        myHttp.findProjectFileRecordList(this.processForm).then(function (resp) {
          if (resp.data.code == "200") {
            var list = resp.data.data

            for (var i = 0; i < list.length; i++) {
              // list.codeStatus = list.processCode ==1?"已处理":"list.processCode ==2?"
              //     if( list[i].processCode ==1){
              //       list[i].codeStatus ="已处理"
              //     }else if(list[i].processCode ==2){
              //       list[i].codeStatus ="退回"
              //     }else{
              //       list[i].codeStatus ="撤回"
              //     }
              //  // 部门名称
              //     if(list[i].processStatus ==1){
              //       list[i].processName ="生产部"
              //     }else if(list[i].processStatus ==2){
              //       list[i].processName ="采购部"
              //     }else if(list[i].processStatus ==3){
              //       list[i].processName ="综合部"
              //     }else if(list[i].processStatus ==4){
              //       list[i].processName ="分管统筹部"
              //     }else if(list[i].processStatus ==5){
              //       list[i].processName ="公司负责人"
              //     }else if(list[i].processStatus ==6){
              //       list[i].processName ="财务部"
              //     }else if(list[i].processStatus ==7){
              //       list[i].processName ="完成"
              //     }


            }
            that.processList = list
          } else {
            that.$message.error(resp.data.msg);
          }
        }, function () { });
      },
    }

  }
</script>
<style scoped>
  .main-left{
  width: 220px;
  height: 100%;
  position: relative;
  /* overflow: auto; */
  background: #fff;
  border-radius: 0.5vh;
  padding: 1vh 0;
  overflow: auto;
}
.el-main{
  height: 100%;
  padding:0px !important;
  padding-left:10px !important;
  position: relative;
  width:calc(100% - 220px);  
}
  .main-left-search {
    width: 100%;
    height: 10%;
    position: relative;
    display: flex;
    align-content: center;
    align-items: center;
    padding: 1vh;
  }

  .main-left-p {
    width: 100%;
    height: 7%;
    position: relative;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: space-between;
    padding: 0 1vh;
  }

  .main-left-list {
    width: 100%;
    height: 85%;
    position: relative;
    overflow: auto;
  }

  .main-left-list li {
    width: 100%;
    /* height: 9vh; */
    position: relative;
    padding: 2px;
    /* display: flex; */
    align-content: center;
    align-items: center;
    border-bottom: 1px solid #eee;
    cursor: pointer;
  }

  .main-left-list li:hover {
    background: #eee;
  }

  .curEnt {
    background: #E7F1FB;
  }

  .curEnt i,
  .curEnt p {
    color: #5A87F9;
  }

  /* .unit-type{
      width: 20%;
      height: 100%;
      position: relative;
      display: flex;
      justify-content: center;
      justify-items: center;
      align-items: center;
      align-content: center;
      border: 1px solid #0365F2;
      padding: 1.5%;
  } */
  .unit-name {
    width: 80%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    align-content: center;
    padding-left: 1vh;
    flex-wrap: wrap;
  }

  .unit-name p {
    width: 100%;
    text-align: left;
  }

  .main-table {
    width: calc(100% - 220px);
    height: calc(100% - 60px);
    position: relative;
    padding-left: 10px;
    display: flex;
    flex-wrap: wrap;
  }

  .table-head {
    width: 100%;
    height: 10vh;
    position: relative;
    background: #fff;
    border-top-left-radius: 0.5vh;
    border-top-right-radius: 0.5vh;
    display: flex;
    align-content: center;
    align-items: center;
    padding: 2vh;
    justify-content: space-between;
  }

  .table-head-seach {
    width:90%;
    height: 100%;
    position: relative;
    align-items: center;
    display: flex;
  }

  .table-box {
    width: 100%;
    height: calc(100% - 10vh);
    position: relative;
    background: #fff;
    border-bottom-left-radius: 0.5vh;
    border-bottom-right-radius: 0.5vh;
  }

  .box-ent {
    width: 100%;
    height: 10vh;
    position: relative;
    margin-bottom: 1vh;
    background: #fff;
    border-radius: 5px;
    display: flex;
    /* flex-wrap: wrap; */
  }

  .box-ent-l {
    width: 80%;
    height: 100%;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    padding: 2vh;
    align-content: center;
    align-items: center;
  }

  .box-ent-l p {
    width: 33%;
    height: 3vh;
    position: relative;
    text-align: left;
    padding-right: 1vh;
  }

  .box-ent-r {
    width: 20%;
    height: 100%;
    display: flex;
    align-content: center;
    align-items: center;
  }
  .stepNoBtn {
    color: #000;
    height: 110px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .erCode {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    justify-items: center;
    align-content: center;
    align-items: center;
    flex-wrap: wrap;
  }
</style>
<style>
  @import '../../assets/css/common.css';

  /* .el-table--border th,
  .el-table__fixed-right-patch {
    border-bottom: 1px solid #303133;
  }

  .el-table--border td,
  .el-table--border th,
  .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
    border-right: 1px solid #303133;
  }

  .el-table td,
  .el-table th.is-leaf {
    border-bottom: 1px solid #303133;
  }

  .el-table--border,
  .el-table--group {
    border: 1px solid #303133;
  } */
</style>